import { render, staticRenderFns } from "./Setting.vue?vue&type=template&id=33d8a7fd"
import script from "./Setting.vue?vue&type=script&lang=js"
export * from "./Setting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33d8a7fd')) {
      api.createRecord('33d8a7fd', component.options)
    } else {
      api.reload('33d8a7fd', component.options)
    }
    module.hot.accept("./Setting.vue?vue&type=template&id=33d8a7fd", function () {
      api.rerender('33d8a7fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Setting/Setting.vue"
export default component.exports